<template>
  <b-col
    class="form-box card-data-block"
    :class="customClass"
  >
    <template v-if="patient">
      <div
        v-if="patient.address"
        class="structure"
      >
        <span class="structure__heading">
          <i
            class="far fa-envelope mr-2"
            aria-hidden="true"
          />
          {{ $t('global.contactData') }}
        </span>
        <b-row class="mt-1">
          <b-col
            lg="6"
            md="12"
          >
            <div class="structure__data">
              <small>{{ $tc('global.address') }}</small>
              <h4
                v-testing="'patient-address'"
                class="collapsable-card-title inside"
              >
                {{ patient.address.address ? patient.address.address : '' }}
              </h4>
            </div>
          </b-col>
          <b-col lg="6">
            <div class="structure__data">
              <small>{{ $tc('global.municipality') }}</small>
              <h4
                v-testing="'patient-municipality'"
                class="collapsable-card-title inside"
              >
                {{ patient.address.municipality ? patient.address.municipality.name : '' }}
              </h4>
            </div>
          </b-col>
          <b-col
            lg="4"
            md="4"
          >
            <div class="structure__data">
              <small>{{ $tc('global.province') }}</small>
              <h4
                v-testing="'patient-province'"
                class="collapsable-card-title inside"
              >
                {{ patient.address.province ? patient.address.province.name : '' }}
              </h4>
            </div>
          </b-col>
          <b-col
            lg="4"
            md="4"
          >
            <div class="structure__data">
              <small>{{ $t('global.pc') }}</small>
              <h4
                v-testing="'patient-pc'"
                class="collapsable-card-title inside"
              >
                {{ patient.address.postalCode ? patient.address.postalCode : '' }}
              </h4>
            </div>
          </b-col>
          <b-col
            lg="4"
            md="4"
          >
            <div class="structure__data">
              <small>{{ $tc('global.country') }}</small>
              <h4
                v-testing="'patient-country'"
                class="collapsable-card-title inside"
              >
                {{ patient.address.country ? patient.address.country.name : '' }}
              </h4>
            </div>
          </b-col>
          <b-col lg="12">
            <div class="structure__data">
              <small>{{ $tc('global.email') }}</small>
              <h4
                v-testing="'patient-email'"
                style="word-break: break-word;"
                class="collapsable-card-title inside"
              >
                {{ patient.contactInformation ? patient.contactInformation.email : '' }}
              </h4>
            </div>
          </b-col>
          <b-col md="4">
            <div class="structure__data">
              <small>{{ $tc('global.phone') }} 1</small>
              <h4
                v-testing="'patient-main-phone'"
                class="collapsable-card-title inside"
              >
                {{ patient.contactInformation ? patient.contactInformation.mainPhone : '' }}
              </h4>
            </div>
          </b-col>
          <b-col md="4">
            <div class="structure__data">
              <small>{{ $tc('global.phone') }} 2</small>
              <h4
                v-testing="'patient-other-phone-1'"
                class="collapsable-card-title inside"
              >
                {{ patient.contactInformation ? patient.contactInformation.otherPhone1 : '' }}
              </h4>
            </div>
          </b-col>
          <b-col md="4">
            <div class="structure__data">
              <small>{{ $tc('global.phone') }} 3</small>
              <h4
                v-testing="'patient-other-phone-2'"
                class="collapsable-card-title inside"
              >
                {{ patient.contactInformation ? patient.contactInformation.otherPhone2 : '' }}
              </h4>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
    <div
      v-else
      class="empty-block my-3"
      style="opacity: .1"
    />
  </b-col>
</template>

<script>
export default {
    name: 'PatientAddressInfoCard',
    props: {
        patient: { type: Object, default: null },
        customClass: { type: Array }
    }
}
</script>
